import { render, staticRenderFns } from "./BLContainerCgoPop.vue?vue&type=template&id=22ba419f"
import script from "./BLContainerCgoPop.vue?vue&type=script&lang=js"
export * from "./BLContainerCgoPop.vue?vue&type=script&lang=js"
import style0 from "./BLContainerCgoPop.vue?vue&type=style&index=0&id=22ba419f&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ba419f')) {
      api.createRecord('22ba419f', component.options)
    } else {
      api.reload('22ba419f', component.options)
    }
    module.hot.accept("./BLContainerCgoPop.vue?vue&type=template&id=22ba419f", function () {
      api.rerender('22ba419f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLContainerCgoPop.vue"
export default component.exports